import { createErrorHandlerWithPackageContext, logErrorMessageWithPackageContext, logExceptionWithPackageContext, logInfoMessageWithPackageContext } from '@atlassian/teams-client/sentry';
const packageContext = {
  packageName: "@atlassian/teams",
  packageVersion: "2.30.0"
};
export { useTeamsSentryClientSetup as useSentryClient } from '@atlassian/teams-client/sentry';
export const logException = logExceptionWithPackageContext(packageContext);
export const logErrorMessage = logErrorMessageWithPackageContext(packageContext);
export const logInfoMessage = logInfoMessageWithPackageContext(packageContext);
export const createErrorHandler = createErrorHandlerWithPackageContext(packageContext);